/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceTeamMemberRequest } from './ServiceTeamMemberRequest';
import {
	ServiceTeamMemberRequestFromJSON,
	ServiceTeamMemberRequestFromJSONTyped,
	ServiceTeamMemberRequestToJSON,
} from './ServiceTeamMemberRequest';

/**
 * Payload to update a service team
 * @export
 * @interface UpdateServiceTeamRequest
 */
export interface UpdateServiceTeamRequest {
	/**
	 * The name of the service team
	 * @type {string}
	 * @memberof UpdateServiceTeamRequest
	 */
	name?: string;
	/**
	 * The description of the service team
	 * @type {string}
	 * @memberof UpdateServiceTeamRequest
	 */
	description?: string;
	/**
	 * The service team members to add or update.
	 * @type {Array<ServiceTeamMemberRequest>}
	 * @memberof UpdateServiceTeamRequest
	 */
	membersToAddOrUpdate?: Array<ServiceTeamMemberRequest>;
	/**
	 * The RIDs of the service team members to delete from service team.
	 * @type {Array<string>}
	 * @memberof UpdateServiceTeamRequest
	 */
	membersToDelete?: Array<string>;
}

/**
 * Check if a given object implements the UpdateServiceTeamRequest interface.
 */
export function instanceOfUpdateServiceTeamRequest(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function UpdateServiceTeamRequestFromJSON(json: any): UpdateServiceTeamRequest {
	return UpdateServiceTeamRequestFromJSONTyped(json, false);
}

export function UpdateServiceTeamRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpdateServiceTeamRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		name: !exists(json, 'name') ? undefined : json['name'],
		description: !exists(json, 'description') ? undefined : json['description'],
		membersToAddOrUpdate: !exists(json, 'membersToAddOrUpdate')
			? undefined
			: (json['membersToAddOrUpdate'] as Array<any>).map(
					ServiceTeamMemberRequestFromJSON
			  ),
		membersToDelete: !exists(json, 'membersToDelete')
			? undefined
			: json['membersToDelete'],
	};
}

export function UpdateServiceTeamRequestToJSON(
	value?: UpdateServiceTeamRequest | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		name: value.name,
		description: value.description,
		membersToAddOrUpdate:
			value.membersToAddOrUpdate === undefined
				? undefined
				: (value.membersToAddOrUpdate as Array<any>).map(ServiceTeamMemberRequestToJSON),
		membersToDelete: value.membersToDelete,
	};
}
